import React from 'react';
import { ISmartProps } from './types';
import { View } from './view';
import * as meta from '../../meta-data.json';

export type SpinnerProps = Omit<ISmartProps, 'css'>;

export const Spinner = React.forwardRef(({ ...props }: SpinnerProps, ref: any) => {
	return <View
		ref={ref}
		aria-label="loading"
		data-epo={`epo-spinner-${meta.version}`}
		{...{ part: `epo-spinner-${meta.version}` }}
		{...props}
	/>;
});